module.exports = __webpack_public_path__ + "img/sg_feature3.28e7eed4.jpg";